import React from "react";

/**
 * Panel Resizer Component - Drag handle between question panel and editor
 */
const PanelResizer = ({ onDragStart, isDragging, isMobile }) => {
  if (isMobile) return null;

  return (
    <div
      onMouseDown={onDragStart}
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize panels"
      title="Drag to resize"
      style={{
        height: "100%",
        width: "4px",
        cursor: "col-resize",
        marginLeft: "8px",
        backgroundColor: isDragging ? "#e0e0e0" : "#f5f5f5",
        position: "relative",
        transition: "background-color 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = "#e0e0e0";
      }}
      onMouseLeave={(e) => {
        if (!isDragging) {
          e.target.style.backgroundColor = "#f5f5f5";
        }
      }}
    />
  );
};

export default PanelResizer;
